
  Vue.component('vue-recaptcha', VueRecaptcha.VueRecaptcha)

  Vue.component('dynamic-form-item', {
    props: {
      id: Number,
      fieldName: { type: String, required: true },
      label: { type: String, default: '' },
      value: { type: String, default: '' },
      valueIfChecked: { type: String, default: 'true' },
      active: { type: Boolean, default: true },
      inputClass: { type: Array, default: () => [] },
      skip: { type: Boolean, default: false },
      hideIfEmpty: { type: Boolean, default: false },
      readOnly: { type: Boolean, default: false },
      validators: { type: Array, default: () => [] },
      inputType: { type: String, default: 'input' },
      typeahead: { type: Object }, // {bloodhoundSource, valueProp, labelProp, sortProp}
      getFieldValue: { type: Function, default: fieldName => null },
      checkValidation: { type: Boolean, default: false },
      options: { type: Array },
      nobr: { type: Boolean, default: true },
      action: { type: Function, default: () => null },
      placeholder: { type: String }
    },
    data() {
      return {
        validationMessage: [],
        typeaheadValues: [],
        isTyping: false,
        onFocus: false
      }
    },
    template: '#dynamic-form-item',
    computed: {
      required() {
        return this.validators.filter(validator => validator.type == 'required').length > 0
      },

      typeaheadPlaceholder() {
        let retVal = ''
        if (
          this.typeahead &&
          this.typeaheadValues.length === 1 &&
          this.typeaheadValues[0].label.toLowerCase().startsWith(this.value.toLowerCase())
        ) {
          retVal = this.typeaheadValues[0].label.replace(new RegExp(`(${this.value})`, 'gmi'), this.value)
        }
        return retVal
      }
    },
    watch: {
      checkValidation(val) {
        if (val) {
          this.validate()
        } else {
          this.validationMessage = []
        }
      }
    },
    methods: {
      handleButtonClick() {
        if (this.action) {
          this.action()
        }
      },
      highlightText(a, b) {
        return a.replace(new RegExp(`(${b})`, 'gmi'), '<b>$1</b>')
      },
      handleInput(e) {
        // this.typeaheadValues = []
        const { value } = e.target

        this.isTyping = true
        this.setValue({ label: value, code: '' })
        this.handleTypeahead(value)
        this.debounceValueInput(e.target.value)
      },
      handleCheckBoxClick(e) {
        const value = e.target.checked ? this.valueIfChecked : ''
        this.setValue({ label: value })
      },
      handleRadioClick(e, option) {
        const value = e.target.checked ? option.valueIfChecked : ''
        this.setValue({ label: value })
      },
      handleTab(e) {
        const filteredItem = this.typeaheadValues.filter(xx => xx.label.toLowerCase() == this.value.toLowerCase())
        const item =
          filteredItem.length == 1
            ? filteredItem[0]
            : this.typeaheadValues.length == 1
            ? this.typeaheadValues[0]
            : { label: this.value, code: '' }

        if (this.value != item.label) {
          e.preventDefault()
          e.stopPropagation()
        }
        this.setValue(item)
      },
      handleEnter(e) {
        if (this.nobr) e.preventDefault()
      },
      handleBlur(e) {
        const filteredItem = this.typeaheadValues.filter(xx => xx.label.toLowerCase() == this.value.toLowerCase())
        const item =
          filteredItem.length == 1
            ? filteredItem[0]
            : this.typeaheadValues.length == 1
            ? this.typeaheadValues[0]
            : { label: this.value, code: '' }

        if (item) this.setValue(item)

        this.onFocus = false
        this.validate()
      },
      handleInputEnter() {
        this.$emit('confirm', { fieldName: this.fieldName, value: this.value })
      },
      handleFocus() {
        this.onFocus = true
        this.typeaheadValues = []
        this.handleTypeahead(this.value)
      },
      handleTypeahead(value) {
        if (this.typeahead) {
          const query = `${value}${
            this.typeahead.filterField ? `|${this.getFieldValue(this.typeahead.filterField)}` : ''
          }`
          this.typeahead.bloodhoundSource.search(query, null, datum => {
            this.typeaheadValues = datum
              // .filter(item =>
              //  this.typeahead.filterProp
              //    ? item[this.typeahead.filterProp] == this.getFieldValue(this.typeahead.filterField)
              //    : true
              // )
              .map(item => ({
                code: item[this.typeahead.valueProp],
                label: item[this.typeahead.labelProp]
              }))
          }) // Per ora gestisco solo remoto
        }
      },
      handleTypeaheadClick(item) {
        this.typeaheadValues = [item]
        this.setValue(item)
        this.$emit('confirm', { fieldName: this.fieldName, value: item.label })
        setTimeout(() => {
          this.$refs.input.focus()
        }, 100)
      },
      handleParentInput(event) {
        this.$emit('input', { ...event })
      },
      setValue(item) {
        this.$emit('input', { fieldName: this.fieldName, value: item.label })
        if (this.typeahead && this.typeahead.valueField) {
          this.$emit('input', { fieldName: this.typeahead.valueField, value: item.code })
        }
      },
      debounceValueInput: _.debounce(function (value) {
        this.isTyping = false
      }, 300),
      validate() {
        const self = this
        self.validationMessage = []
        // if (this.required && `${this.value}` == '') self.validationMessage.push('Campo obbligatorio')

        if (self.inputType === 'hidden') return true

        this.validators
          .filter(validator => validator.type === 'required')
          .forEach(validator => {
            if (this.value === '' || this.value === undefined) {
              self.validationMessage.push(
                validator.hasOwnProperty('message') ? validator.message : 'Campo obbligatorio'
              )
            }
          })

        if (self.validationMessage.length === 0 && !this.value) {
          this.validators
            .filter(validator => validator.type === 'requiredOtherFields')
            .forEach(validator => {
              let otherFieldsAreNull = true
              validator.requiredOtherFields.forEach(otherField => {
                const retVal = self.getFieldValue(otherField)
                otherFieldsAreNull = otherFieldsAreNull && (retVal === '' || retVal === undefined)
              })
              if (otherFieldsAreNull) {
                self.validationMessage.push(validator.message)
              }
            })
        }

        if (self.validationMessage.length === 0 && this.value) {
          this.validators
            .filter(validator => validator.type === 'regex')
            .forEach(validator => {
              const re = new RegExp(validator.regex)
              if (!re.test(this.value)) self.validationMessage.push(validator.message)
            })
        }

        if (self.validationMessage.length === 0 && this.value) {
          this.validators
            .filter(validator => validator.type === 'equalOtherFields')
            .forEach(validator => {
              let otherFieldsAreEquals = true
              validator.equalOtherFields.forEach(otherField => {
                const retVal = self.getFieldValue(otherField)
                otherFieldsAreEquals = otherFieldsAreEquals && retVal === self.value
              })
              if (!otherFieldsAreEquals) {
                self.validationMessage.push(validator.message)
              }
            })
        }

        if (self.validationMessage.length === 0 && this.value) {
          this.validators
            .filter(validator => validator.type === 'remote')
            .forEach(validator => {
              const sendData = {
                [validator.valueParam || 'value']: self.value
              }
              if (validator.hasOwnProperty('extraParam')) {
                Object.entries(validator.extraParam).forEach(
                  ([key, value]) => (sendData[key] = value instanceof Function ? value() : value)
                )
              }
              axios[validator.method](validator.url, sendData).then(response => {
                const { data } = response
                const result = validator.responseEval ? eval(`data.${validator.responseEval}`) : data
                if (!result) self.validationMessage.push(validator.message)
              })
            })

          if (this.typeahead && !this.typeahead.valueNotInList) {
            let bhValide = true
            const query = `${this.value}${
              this.typeahead.filterField ? `|${this.getFieldValue(this.typeahead.filterField)}` : ''
            }`
            this.typeahead.bloodhoundSource.search(query, null, datum => {
              const filteredDatum = datum.filter(
                item => item[self.typeahead.labelProp].toLowerCase() === self.value.toLowerCase()
              )
              if (filteredDatum.length === 0) {
                bhValide = false
                self.validationMessage.push('Selezionare un valore in elenco')
              }
            })
            if (
              bhValide &&
              this.typeahead.valueField &&
              this.validators.filter(val => val.type === 'required').length > 0 &&
              this.getFieldValue(this.typeahead.valueField) === ''
            ) {
              self.validationMessage.push('Selezionare un valore in elenco')
            }
          }
        }

        return self.validationMessage.length === 0
      },
      emitInterface() {
        const self = this
        this.$emit('interface', {
          key: self.fieldName,
          validate: () => self.validate(),
          containerRef: self.$refs.container
        })
      },
      onCaptchaVerified(recaptchaToken) {
        // console.log('CAPTCHA VERIFIED', recaptchaToken)
        this.setValue({ label: recaptchaToken })
      },
      onCaptchaExpired() {
        // console.log('CAPTCHA EXPIRED')
        this.setValue({ label: null })
      },
      onCaptchaError() {
        // console.log('CAPTCHA ERROR')
        this.setValue({ label: null })
      }
    },
    mounted() {
      this.emitInterface()
    }
  })
